import * as Yup from 'yup'
import React, { useState, useEffect, useRef, useCallback } from 'react'
// import {
//   GoogleMap,
//   LoadScript,
//   InfoWindow,
//   DirectionsRenderer,
//   Marker,
// } from '@react-google-maps/api'
import {
  defaultZipCode,
  GOOGLE_API_KEY,
  PUBNUB_PUBLISH_KEY,
  PUBNUB_SECRET_KEY,
  PUBNUB_SUBSCRIBE_KEY,
  REST_API_END_POINT,
  MAPBOX_ACCESS_TOKEN
} from 'src/constants/Defaultvalues'
import PubNub from 'pubnub'
import axios from 'axios'
import { Form, FormikProvider, useFormik } from 'formik'
import {
  Box,
  Card,
  Grid,
  Stack,
  TextField,
  Button,
  Autocomplete,
  Typography,
  CardContent,
  Tab,
  Tabs,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Chip,
  Avatar,
  Divider,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Popover,
  Tooltip,
} from '@material-ui/core'
import { LoadingButton, TabContext, TabList, TabPanel } from '@material-ui/lab'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'
import LoadingScreen from 'src/components/LoadingScreen'
import { useSnackbar } from 'notistack'
import { Close, Delete, KeyboardBackspaceOutlined, Place, Refresh, WorkOutline, PersonOutline, Business } from '@material-ui/icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import homeIcon from '../../../../src/assets/active-routes-home.png'
import { MButtonGroup } from 'src/components/@material-extend'
import truckIcon from 'src/assets/delivery.svg'
import installationIcon from 'src/assets/2jKMY8AFOqiToSHy1XkhiN26QCc.svg'
import car from 'src/assets/car-removebg-preview.png'
import truck from 'src/assets/semi.png'
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import Scrollbar from 'src/components/Scrollbar'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs'
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick'
import moment from 'moment'
import mapboxgl from 'mapbox-gl'
import MapBoxComponent from 'src/pages/dashboard/MapComponent'
import { mapboxDirections } from 'src/utils/decodePolyline'
mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN



function calculateDistance(p1, p2) {
  const R = 6371; // Radius of Earth in km
  const dLat = ((p2.lat - p1.lat) * Math.PI) / 180;
  const dLon = ((p2.lng - p1.lng) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((p1.lat * Math.PI) / 180) *
      Math.cos((p2.lat * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function tspSolver(locations, startPoint) {
  const visited = new Array(locations.length).fill(false);
  const route = [];
  let current = startPoint;

  for (let i = 0; i < locations.length; i++) {
    let nearest = -1;
    let minDist = Infinity;
    for (let j = 0; j < locations.length; j++) {
      if (!visited[j]) {
        const dist = calculateDistance(current, locations[j]);
        if (dist < minDist) {
          minDist = dist;
          nearest = j;
        }
      }
    }
    visited[nearest] = true;
    route.push(locations[nearest]);
    current = locations[nearest];
  }

  return route;
}



const MapComponent2 = ({
  driverDataaa,
  home,
  selectedSalesOrder,
  setSelectedSalesOrder,
  selectedRoute,
  setSelectedRoute,
  locations,
  setLocations,
  directions,
  setDirections,
  getLatandLongFromAddress,
  selectedData,
  isFromPs,
  sales_order_id,
  details
}) => {
  const [markers, setMarkers] = useState([])
  const [apiLoaded, setApiLoaded] = useState(false)
  const [selectedMarker, setSelectedMarker] = useState(null)
  const [selectedDriverId, setSelectedDriverId] = useState(null)
  const [selectedDriver, setSelectedDriver] = useState(null)
  const [selectProject, setSelectProject] = useState(null)
  const [isDriver, setIsDriver] = useState(true)
  const [selectedTeam, setSelectedTeam] = useState(null)
  const [selectTemplate, setSelectTemplate] = useState(null)
  const [templates, setTemplates] = useState([])
  const [salesOrderData, setSalesOrderData] = useState([])
  const [routeData, setRouteData] = useState([])
  // const [locations, setLocations] = useState([]);
  // const [directions, setDirections] = useState([]);
  const [originalDriverId, setOriginalDriverId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingTeam, setLoadingTeam] = useState(false)
  const [previosSalesOrderId, setPreviosSalesOrderid] = useState(null)
  const navigate = useNavigate()
  const [selectedOriginalDriverId, setSelectedOriginalDriverId] = useState(null)
  const [updatedRoute, setUpdatedRoute] = useState(false)
  const [allAppointmentData, setAllAppointmentData] = useState([])
  const [teamMembers, setTeamMembers] = useState([])
  const [addedLocations, setAddedLocations] = useState([])
  const [deleteLocationIndex, setDeleteLocationIndex] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [allProducts, setAllproducts] = useState([])
  const [selectedProducts, setSelectedProducts] = useState([])
  const [tooltipInfo, setTooltipInfo] = useState([])
  const [markerPopup, setMarkerPopup] = useState({ open: false, location: null })
  const [mapOrderData,setMapOrderData] = useState([])
  const [isSaving, setIsSaving] = useState(false);
  

  // const [geocoder] = useState(new window.google.maps.Geocoder());
  const { enqueueSnackbar } = useSnackbar()
  const userData = JSON.parse(window.localStorage.getItem('user'))
  const userId = userData.user_id
  const explodedPermissions = userData?.exploded_permissions
  const hasRouteMovingPermission =( explodedPermissions?.some((permission) =>
    ['Route Management (Route Map)'].includes(permission),
  ) && (!details?.allInstallationCompleted && details?.installationCompleteStatus == null ) )
    ? true
    : false

console.log('hasRouteMovingPermission 1', hasRouteMovingPermission)

  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedLocation, setSelectedLocation] = useState(null)
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const popoverTimer = useRef(null)
  const hoverTimeout = useRef(null); 

    /* ---------- hover helpers ---------- */
const handleMarkerHover = useCallback((location, mousePos) => {
  clearTimeout(hoverTimeout.current);
  setSelectedLocation(location);
  setMousePosition(mousePos);
  setMarkerPopup({ open: true, location })
}, []);

 const handleMarkerLeave = useCallback(() => {
  hoverTimeout.current = setTimeout(() => {
        setSelectedLocation(null);
        setMousePosition(null);
      }, 150);
}, []);



const handleMarkerClick = (location, mousePos) => {
  setSelectedLocation(location)
  setMousePosition(mousePos)   // if you still position pop-over by cursor
  setMarkerPopup({ open:true, location })
}

const handleSetAsPoint = (type, location) => {
  const updated = addedLocations.map((loc) => {
    const isSame = loc?.index === location?.index

  
      return {
      ...loc,
      starting_point:
        type === 'start'
          ? isSame // set only this as start
            ? true
            : false // unset all others
          : type === 'both'
          ? isSame // set both
            ? true
            : false
          : type === 'end' && isSame
          ? false // if setting as end, remove start on the same location
          : type === 'remove' && isSame
          ? false // remove start if this is the one
          : loc.starting_point, // otherwise leave untouched

      ending_point:
        type === 'end'
          ? isSame
            ? true
            : false
          : type === 'both'
          ? isSame
            ? true
            : false
          : type === 'start' && isSame
          ? false // if setting as start, remove end on same
          : type === 'remove' && isSame
          ? false
          : loc.ending_point,
    }
  })

  setAddedLocations(updated)
  setMarkerPopup({ open: false, location: null })

    clearTimeout(hoverTimeout.current);
    setSelectedLocation(null);
    setMousePosition(null);
}





  const handlePopoverOpen = (event, location) => {
    clearTimeout(popoverTimer.current)

    let updatedLocation = { ...location }
    if (location.service_id !== null) {
      updatedLocation.attachments = location?.attachments?.length
        ? location.attachments
        : location?.service_image
        ? [{ name: location.service_image }]
        : []
    }

    popoverTimer.current = setTimeout(() => {
      setMousePosition({
        x: event.clientX ?? event?.domEvent?.clientX,
        y: event.clientY ?? event?.domEvent?.clientY,
      })
      setAnchorEl(event.target ?? event?.domEvent?.target)
      setSelectedLocation(updatedLocation)
      console.log(
        'Popover Opened at:',
        event.clientX ?? event?.domEvent?.clientX,
        event.clientY ?? event?.domEvent?.clientY,
      )
      console.log('Updated Location Data:', updatedLocation)
    }, 200)
  }

  const handlePopoverClose = () => {
    clearTimeout(popoverTimer.current)
    setAnchorEl(null)
    setSelectedLocation(null)
  }

  const open = Boolean(anchorEl)

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 2000, // Changes every 2 seconds
    beforeChange: (oldIndex, newIndex) => setCurrentImageIndex(newIndex), // Track current slide
    customPaging: (i) => (
      <div
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: i === currentImageIndex ? '#007BFF' : '#ccc', // Active dot color
          margin: '0px',
        }}
      />
    ),
    dotsClass: 'slick-dots slick-thumb',
  }



  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true)
      try {
        const response = await axios.post(
          `${REST_API_END_POINT}route/get-all-products-for-wed-route`,
        )
        const productListData = response.data.results
        if (productListData) {
          setAllproducts(productListData)
        } else {
          setAllproducts([])
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        setAllproducts([])
      } finally {
        setLoading(false)
      }
    }
    fetchProducts()
  }, [])

  const generateRandomMarkers = (qty, center, color) => {
    const markers = []
    for (let i = 0; i < qty; i++) {
      const randomLat = center.lat + (Math.random() - 0.5) * 0.02
      const randomLng = center.lng + (Math.random() - 0.5) * 0.02
      markers.push({
        lat: randomLat,
        lng: randomLng,
        color,
      })
    }
    return markers
  }

  
// const generateRandomColor = () => {
//   const randomHue = () => {
//     let hue;
//     do {
//       hue = Math.floor(Math.random() * 360);
//     } while (
//       (hue >= 0 && hue <= 20) ||      // exclude red
//       (hue >= 80 && hue <= 160) ||   // exclude green
//       (hue >= 340 && hue <= 360)     // also red wraparound
//     );
//     return hue;
//   };

//   const hue = randomHue();
//   const saturation = Math.floor(60 + Math.random() * 30); // 60–90%
//   const lightness = Math.floor(40 + Math.random() * 30);  // 40–70%

//   return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
// };


const generateRandomColor = () => {
  const hue = Math.floor(Math.random() * 360);               // 0 - 359
  const saturation = Math.floor(Math.random() * 51) + 50;    // 50% - 100%
  const lightness = Math.floor(Math.random() * 41) + 30;     // 30% - 70%
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

const reverseGeocodeMapbox = async (lat, lng) => {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_ACCESS_TOKEN}`;
  const res  = await fetch(url);
  if (!res.ok) throw new Error('Mapbox geocode failed');
  const { features = [] } = await res.json();
  const place = features[0];

  if (!place) return {};

  /* pull bits you care about */
  const cmp = Object.fromEntries(
    place.context.map(c => [c.id.split('.')[0], c.text])
  );

  return {
    wholeAddress : place.place_name,
    address      : place.text,            // street / POI
    city         : cmp.place     || null,
    state        : cmp.region    || null,
    zip          : cmp.postcode  || null,
    country      : cmp.country   || null,
  };
};

const handleProductQuantityChange = async (product, newQty, index) => {
  /* ---------- colour (stable per product) ---------------------- */
  if (!product.color) product.color = generateRandomColor();
  const color = product.color;

  /* ---------- update qty + colour in selectedProducts ---------- */
  setSelectedProducts((prev) =>
    prev.map((p, idx) =>
      idx === index ? { ...p, qty: newQty, color } : p
    )
  );

  /* ---------- compute keep / add ------------------------------ */
  const currentForProd = addedLocations.filter(
    (l) => l.productId === product.id
  );
  const keep   = currentForProd.slice(0, newQty);   // retain up to newQty
  const toAdd  = newQty - keep.length;              // missing pins (may be < 0)

  if (toAdd < 0) {
    // qty decreased – simply trim excess pins
    const withoutProd = addedLocations.filter(
      (l) => l.productId !== product.id
    );
    const merged = [...withoutProd, ...keep].map((m, i) => ({
      ...m,
      index: i + 1,
    }));
    setAddedLocations(merged);
    return;
  }

  /* ---------- build new pins w/ Mapbox geocode ---------------- */
  const newMarkers = await Promise.all(
    Array.from({ length: toAdd }).map(async () => {
      const lat = home.lat + (Math.random() - 0.5) * 0.02;
      const lng = home.lng + (Math.random() - 0.5) * 0.02;

      let addrParts = {};
      try {
        addrParts = await reverseGeocodeMapbox(lat, lng);
      } catch (err) {
        console.warn('Mapbox geocode failed:', err.message);
      }

      return {
        /* position */
        lat,
        lng,
        /* product info */
        productId: product.id,
        productName: product.name,
        color,
        quantity: 1,
        /* address fields (may be blank) */
        ...addrParts,
      };
    })
  );

  /* ---------- merge + re-index -------------------------------- */
  const withoutProd = addedLocations.filter(
    (l) => l.productId !== product.id
  );
  const merged = [...withoutProd, ...keep, ...newMarkers].map((m, i) => ({
    ...m,
    index: i + 1,
  }));

  setAddedLocations(merged);
};

const handleChangeProductColor = (productId) => {
  const newColor = generateRandomColor();

  // 1. Update selectedProducts
  setSelectedProducts((prev) =>
    prev.map((product) =>
      product.id === productId ? { ...product, color: newColor } : product
    )
  );

  // 2. Update addedLocations
  setAddedLocations((prev) =>
    prev.map((location) =>
      location.productId === productId ? { ...location, color: newColor } : location
    )
  );
};


  const handleUpdateProductsAddress = async (data) => {
    console.log('productsssssssss', data)
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}rfq/update-products-route`,
        data,
      )
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' })
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' })
      }
    } catch (error) {
      console.log('Server error:', error)
      enqueueSnackbar('Server error', { variant: 'error' })
    }
  }

  const handleUpdateServiceAddress = async (data) => {
    console.log('view dataaaa>', data)
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}rfq/update-service-route`,
        data,
      )
      if (response.data.status === 1) {
        console.log('address updated')
        enqueueSnackbar(response.data.message, { variant: 'success' })
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' })
      }
    } catch (error) {
      console.log('Server error:', error)
      enqueueSnackbar('Server error', { variant: 'error' })
    }
  }

  const handleSaveLocations = async () => {
    try {
     setIsSaving(true);

      const response = await axios.post(
        `${REST_API_END_POINT}route/save-locations`,
        { selectedRoute, addedLocations, selectedProducts, userId },
      )
      if (response.data.status === 1) {
        enqueueSnackbar('Locations saved successfully!', { variant: 'success' })
        // navigate(PATH_DASHBOARD.transportation.routes, { state: { ts: true } })
      } else {
        enqueueSnackbar('Failed to save locations.', { variant: 'error' })
      }
    } catch (error) {
      console.error('Error saving locations:', error)
      enqueueSnackbar('An error occurred while saving locations.', {
        variant: 'error',
      })
    }finally {
    setIsSaving(false); 
  }
  }

  const handleSaveLocationsAuto = async (data) => {
    try {
      if (!data || !data.location_id) {
        console.error('Invalid data: location_id is required')
        return
      }
      console.log('productsssssssss', data)
      // Update locations in addedLocations where location_id matches
      const newAddedLocations = addedLocations?.map((item) => {
        if (item.location_id === data.location_id) {
          return {
            ...item, // Keep existing properties
            address: data.address !== undefined ? data.address : item.address,
            city: data.city !== undefined ? data.city : item.city,
            state: data.state !== undefined ? data.state : item.state,
            zip: data.zip !== undefined ? data.zip : item.zip,
            lat: data.lat !== undefined ? data.lat : item.lat,
            lng: data.lng !== undefined ? data.lng : item.lng,
          }
        }
        return item // Return unchanged locations if no match
      })

      console.log('Updated Locations:', newAddedLocations)

      const response = await axios.post(
        `${REST_API_END_POINT}route/save-locations`,
        {
          selectedRoute,
          addedLocations: newAddedLocations,
          selectedProducts,
          userId,
        },
      )
      if (response.data.status === 1) {
        // enqueueSnackbar('Locations saved successfully!', { variant: 'success' });
        console.log('Locations saved successfully!', response.data)
      } else {
        // enqueueSnackbar('Failed to save locations.', { variant: 'error' });
        console.log('Failed to save locations', response.data)
      }
    } catch (error) {
      console.error('Error saving locations:', error)
      enqueueSnackbar('An error occurred while saving locations.', {
        variant: 'error',
      })
    }
  }

const handleMarkerDrag = async (point, key, location) => {
  // if(hasRouteMovingPermission) return enqueueSnackbar('Access Denied You do not have sufficiant permission.', {variant: 'error',})
  // console.log('hasRouteMovingPermission', hasRouteMovingPermission)
  console.log('handleMarkerDraglocation 1',location)
  console.log('handleMarkerDraglocation point', point)
  if (!point) return
  const { lat: newLat, lng: newLng } = point

  /* 1️⃣ optimistic UI update – functional form (race-safe) */
  setAddedLocations(prev => {
    const idx = prev.findIndex(
      l => String(l.index) === String(key)
    )
    console.log('handleMarkerDraglocation idx', point)
    if (idx === -1) return prev
    const next = [...prev]
    next[idx] = { ...next[idx], lat: newLat, lng: newLng }
    console.log('handleMarkerDraglocation 2', next)
    return next
  })

  
  try {
    const patch = await reverseGeocodeMapbox(newLat, newLng) // wholeAddress, address, city …

    /* 3️⃣ merge geocode result into state (race-safe) */
    setAddedLocations(prev => {
      const idx = prev.findIndex(
        l => String(l.index) === String(key)
        // l => String(l.location_id ?? l.id ?? l.index) === String(key)
      )
      if (idx === -1) return prev
      const next = [...prev]
      next[idx] = { ...next[idx], ...patch, lat: newLat, lng: newLng }
      return next
    })

    /* 4️⃣ persist to backend */
    // if (location?.location_id) {
    //   handleSaveLocationsAuto({
    //     location_id: location.location_id,
    //     lat: newLat,
    //     lng: newLng,
    //     ...patch,
    //   })

    //   if (location.type === 'product') {
    //     await handleUpdateProductsAddress({
    //       location_id: location.location_id,
    //       lat: newLat,
    //       lng: newLng,
    //       ...patch,
    //     })
    //   }
    // }
  } catch (err) {
    console.error('Mapbox geocode failed', err)
  }
}

  const handleMarkerDelete = () => {
    // Create a new array without the deleted location
    const updatedLocations = addedLocations.filter(
      (_, i) => i !== deleteLocationIndex,
    )
    setDeleteLocationIndex(null)
    // Update state and recalculate the route
    setAddedLocations(updatedLocations)
    calculateRoutes(updatedLocations)
  }

  const handleFetchLocations = async () => {
    try {
      setIsLoading(true)
      let response
      if (isFromPs) {
        response = await axios.post(
          `${REST_API_END_POINT}route/fetch-locations-sales-id`,
          { selectedRoute },
        )
      } else {
        response = await axios.post(
          `${REST_API_END_POINT}route/fetch-locations-route-id`,
          { selectedRoute,sales_order_id },
        )
      }
      console.log('response.data-----', response.data)
      console.log('response.data-allProducts-----', allProducts)
      if (response.data.status === 1) {
        const routeData = response.data.routeData || null
        const productData = response.data.productData || null
        const newProducts = productData
          ? await Promise.all(
              productData.map(async (item) => {
                const filteredProduct = allProducts?.find(
                  (prod) => prod.id == item.product_id,
                )
                if (!filteredProduct) {
                  console.warn(
                    `Product with ID ${item.product_id} not found in allProducts`,
                  )
                  return null // Skip or handle missing product
                }
                const color = item?.color || generateRandomColor()
                return {
                  ...filteredProduct,
                  qty: item.qty || 0, // Ensure qty has a default value of 0
                  color,
                }
              }),
            )
          : []
        console.log('newProducts=1====', newProducts)
        setSelectedProducts(newProducts.filter(Boolean)) // Remove any null values
        const newLocations =
          routeData &&
          (await Promise.all(
            routeData?.map(async (item) => {
              console.log('item=====', item)
              const product = newProducts?.find(
                (prod) => prod.id == item.product_id,
              )
             
              return {
                type: 'product',
                is_dos: item?.is_dos || null,
                location_id: item?.request_location_id,
                lat: item.latitude ? parseFloat(item.latitude) : null,
                lng: item.longitude ? parseFloat(item.longitude) : null,
                address: item.address || null, // Use geocoded address if available
                city: item.city || null,
                state: item.state || null,
                zip: item.zip || null,
                color: product ? product.color : 'black',
                productId: product ? product.id : null,
                productName: product ? product.name : null,
                service_image: product?.service_image || null,
                country: item.country || 'USA',
                attachments: item.attachments || [],
                quantity: '1' || item.quantity || 0,
                wholeAddress: item.wholeAddress || null,
                route_locations_id: item?.id || null,
                index: item?.index_order || null,
                starting_point: item?.starting_point || null,
                ending_point: item?.ending_point || null,
              }
            }),
          ))
        console.log('newLocations=====', newLocations)
        setAddedLocations(newLocations)
       if (apiLoaded) {
  calculateRoutes(newLocations)
}
        
      } else {
        setAddedLocations([])
        setSelectedProducts([])
      }
    } catch (error) {
      console.error('Error fetching locations:', error)
      setAddedLocations([])
      setSelectedProducts([])
    } finally {
      setIsLoading(false)
    }
  }

  console.log('newProducts=2====', selectedProducts)

  useEffect(() => {
    if ((allProducts?.length > 0 && selectedRoute) || isFromPs) {
      handleFetchLocations()
    }
  }, [selectedRoute, allProducts, isFromPs,apiLoaded])



  const handleFetchTeam = async () => {
    try {
      setLoadingTeam(true)
      const user = JSON.parse(window.localStorage.getItem('user'))
      const response = await axios.post(
        `${REST_API_END_POINT}installation/all-project`,
        {
          userType: { value: user.user_type },
          userId: { value: user.user_id },
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      if (response.data.status === 1) {
        const TeamData = response.data.TeamMembers
        let DriversData = response.data.allDrivers
        DriversData = DriversData?.filter((row) => row.status === 1)
        const allTeamData = [...DriversData, ...TeamData]
        setTeamMembers(allTeamData)
        let team = allTeamData.find(
          (val) => val?.user_id == selectedData?.team_id,
        )
        if (selectedData.assigned) {
          setSelectedTeam(team)
        }
       

        let driverData = []
        const driverIds =
          selectedData?.driver_id?.split(',').map((id) => id.trim()) || []

        driverIds.forEach((id) => {
          const driver = allTeamData.find((val) => String(val?.id) === id)
          if (driver) {
            driverData.push(driver)
          }
        })

        if (selectedData.assigned) {
          setSelectedDriver(driverData)
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setLoadingTeam(false)
    }
  }

  const fetchAllInstTemplates = async () => {
    try {
      axios
        .post(`${REST_API_END_POINT}installation/get-all-template`, {
          value: false,
        })
        .then((res) => {
          if (res.data.status === 1) {
            setTemplates(res.data.result)

            let templateValue = res.data.result.find(
              (val) => val.id == selectedData.installation_temp_id,
            )
            console.log('templates templates 2', templateValue)
            if (selectedData.assigned) {
              setSelectTemplate(templateValue)
            }
          }
        })
        .catch((error) => {
          console.log(error)
          setTemplates([])
        })
    } catch (error) {
      console.log(error)
      setTemplates([])
    }
  }

  useEffect(() => {
    const pubnub = new PubNub({
      publishKey: PUBNUB_PUBLISH_KEY,
      subscribeKey: PUBNUB_SUBSCRIBE_KEY,
      secretKey: PUBNUB_SECRET_KEY,
    })

    pubnub.addListener({
      message: (messageEvent) => {
        const {
          driverId,
          latitude,
          longitude,
          speed,
          customer_name,
          address,
          city,
          state,
          zipcode,
          driver_name,
        } = messageEvent.message
        setSelectedDriverId(driverId)
        setMarkers((prevMarkers) => {
          const existingMarker = prevMarkers.find(
            (marker) => marker.driverId === driverId,
          )
          if (existingMarker) {
            return prevMarkers.map((marker) =>
              marker.driverId === driverId
                ? {
                    ...marker,
                    lat: Number(latitude),
                    lng: Number(longitude),
                    speed,
                  }
                : marker,
            )
          } else {
            return [
              ...prevMarkers,
              {
                driverId,
                lat: latitude,
                lng: longitude,
                speed,
                customer_name,
                address,
                city,
                state,
                zipcode,
                driver_name,
              },
            ]
          }
        })
      },
    })

    pubnub.subscribe({ channels: ['driver_location'] })

    return () => {
      pubnub.unsubscribeAll()
    }
  }, [])

  useEffect(async () => {
    try {
      if (selectedDriverId) {
        const response = await axios.post(
          `${REST_API_END_POINT}driver/get-driver-by-userId`,
          { id: selectedDriverId },
        )
        if (response.data.status === 1) {
          setOriginalDriverId(response.data.result[0].id)
          setSelectedOriginalDriverId(response.data.result[0].id)
        }
      }
    } catch (error) {
      console.log('error', error)
    }
  }, [selectedDriverId])

  const groupAppointmentsByRequestId = (appointments) => {
    const grouped = appointments.reduce((result, appointment) => {
      const { request_id, name, address, city, state, zipcode } = appointment

      // Construct the installationAddress
      const installationAddress = `${address || ''}, ${city || ''}, ${
        state || ''
      }, ${zipcode || ''}`.replace(/(, )+$/, '')

      if (!result[request_id]) {
        result[request_id] = {
          requestId: request_id,
          name: name, // Use the first appointment's name as the group name
          appointments: [],
        }
      }

      result[request_id].appointments.push({
        ...appointment,
        installationAddress, // Add installationAddress to each appointment
      })

      return result
    }, {})

    // Convert the grouped object into an array
    return Object.values(grouped)
  }

  const handleFetchAllAppointments = async () => {
    setLoading(true)
    try {
      const user = JSON.parse(window.localStorage.getItem('user'))
      const explodedPermissions = user?.exploded_permissions
      const hasPermission = explodedPermissions?.some((permission) =>
        ['View All Installations'].includes(permission),
      )
        ? true
        : false
      const response = await axios.post(
        `${REST_API_END_POINT}route/fetch-all-unassigned-installation-salesorder`,
        {
          userType: { value: user.user_type },
          userId: { value: user.user_id },
          hasPermission: hasPermission,
          routeId: selectedData?.assigned == 1 ? selectedRoute : null,
        },
        { headers: { 'Content-Type': 'application/json' } },
      )
      if (response.data.status === 1) {
        if (
          response.data.appointments &&
          response.data.appointments?.length > 0
        ) {
          const allAppointments = response.data.appointments
          const groupedAppointments =
            groupAppointmentsByRequestId(allAppointments)
          console.log(groupedAppointments) // View the grouped structure
          setAllAppointmentData(groupedAppointments)
          let value = groupedAppointments.find(
            (val) =>
              val.appointments[0]?.request_id ===
              selectedData?.assigned_sales_order,
          )

          console.log('loggggggggggg', value)
          if (selectedData.assigned && value) {
            setSelectedSalesOrder(value)
            setPreviosSalesOrderid(value.requestId)
            initializeLocations(value)
            handleSalesOrderSelect(value)
          }
        } else {
          setAllAppointmentData([])
        }
      }
    } catch (error) {
      console.log('Error fetch appointments--', error)
      setAllAppointmentData([])
    } finally {
      setLoading(false)
    }
  }

  const initializeLocations = async (value) => {
    console.log('location data 1', value)

    if (selectedData.assigned && value?.appointments) {
      console.log('location data 2')

      const installations = await fetchInstallationLocations(value.appointments)
      setLocations(installations) // Initialize locations state
      calculateRoute(installations) // Calculate route based on initial locations
      console.log('location data 3', installations)
    }
  }

  useEffect(async () => {
    handleFetchAllAppointments()
    fetchAllInstTemplates()
    handleFetchTeam()
    console.log(
      'selectedData?.driver_is_installer',
      selectedData?.driver_is_installer,
    )
    let installerAsDriver =
      selectedData?.driver_is_installer == 2 ? true : false
    if (selectedData?.assigned) {
      setIsDriver(installerAsDriver)
    }
  }, [selectedData])

  useEffect(() => {
    if (selectedSalesOrder) {
      // Automatically handle the selected sales order and calculate directions
      handleSalesOrderSelect(selectedSalesOrder)
      calculateRoute(locations)
    }
  }, [selectedSalesOrder])



  useEffect(() => {
  const script = document.createElement('script')
script.src = 'https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.js'
script.async = true
script.onload = () => setApiLoaded(true)
document.body.appendChild(script)

const link = document.createElement('link')
link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.css'
link.rel = 'stylesheet'
document.head.appendChild(link)
}, [])

  const fetchLocationData = async (installationData) => {
    try {
      console.log('installationData=========', installationData)
      let installations = []
      if (installationData?.length > 0) {
        for (const data of installationData) {
          const installationAddress = `${data.address}, ${data.city}, ${data.state}, ${data.zipcode}`
          try {
            let latLong = null
            if (!data.lat && !data.lng) {
              latLong = await getLatandLongFromAddress(installationAddress)
            }
            const newData = {
              ...data,
              installationAddress: installationAddress,
              lati: data.lat ? Number(data.lat) : latLong.Latitude,
              longi: data.lng ? Number(data.lng) : latLong.Longitude,
            }
            installations.push(newData)
          } catch (error) {
            console.error('Error fetching lat/long:', error)
          }
        }
        setLocations(installations)
      } else {
        setLocations([])
      }
    } catch (error) {
      console.log('Error fetching location data:', error)
    }
  }

  // useEffect(() => {
  //   if (apiLoaded && (markers.length > 0 || locations.length > 0)) {
  //     console.log(
  //       'apiLoadedapiLoaded',
  //       apiLoaded,
  //       markers.length,
  //       locations.length,
  //     )
  //     calculateRoutes(locations)
  //   }
  // }, [markers, locations, selectedRoute, selectedSalesOrder, apiLoaded])

  useEffect(() => {
    console.log('apiLoadedlocations', apiLoaded,locations.length)
  if (apiLoaded && home && locations.length > 0) {
    console.log('[effect] apiLoaded & locations ready, calculating route')
    calculateRoutes(locations)
  }
}, [apiLoaded, home, locations])







/* 2️⃣  Small helper to measure distance between two Lat/Lng pts */
const haversine = (a, b) => {
  const R = 6371000
  const toRad = (d) => (d * Math.PI) / 180
  const dLat = toRad(b.lat - a.lat)
  const dLng = toRad(b.lng - a.lng)
  const φ1 = toRad(a.lat)
  const φ2 = toRad(b.lat)

  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.sqrt(h))
}
/* --
/* ────────────────────────────────────────────────────────────── */

// SIMPLE A → B → … → A
const calculateRoute = async (locs) => {
  try {
    if (!apiLoaded) return console.warn('Mapbox API not loaded yet.');
  if (!home) return console.warn('Home location not ready.');
  if (!Array.isArray(locs) || locs.length === 0) return console.warn('No locations to route.');

    const pts = [
      { lat: home.lat, lng: home.lng },
      ...locs.map((l) => ({ lat: +l.lat, lng: +l.lng })),
      { lat: home.lat, lng: home.lng },
    ]

    const route = await mapboxDirections(pts)       // helper
    setDirections(route.geometry)                   // GeoJSON LineString
  } catch (err) {
    console.error('[Mapbox] calculateRoute:', err)
    setDirections(null)
  }
}



const isTrue = v => v === true || v === 1 || v === 'true';
const isFiniteNumber = v => typeof v === 'number' && isFinite(v)    

const chunkArray = (arr, max = 25) => {
  const step   = max - 1          // leave space for the overlap
  const chunks = []

  for (let i = 0; i < arr.length; i += step) {
    // slice up to max items
    const chunk = arr.slice(i, i + max)

    // add the overlap (except for the first chunk)
    if (i !== 0) {
      chunk.unshift(arr[i - 1])   // prepend previous point
      if (chunk.length > max) {
        chunk.pop()               // trim to stay ≤ max
      }
    }

    chunks.push(chunk)
  }
  return chunks
}

const calculateRoutes = async (initialLocs  = []) => {
  try {
      //  const locs = initialLocs?.map((l, i) => ({ ...l, index: i + 1 }));
       const locs = initialLocs
       
    

setAddedLocations(locs);

    if (!apiLoaded || !home || !Array.isArray(locs) || !locs.length) {
      console.log('calculateRoutes 1',apiLoaded)
      setMapOrderData([])
      setDirections(null)
      return
    }
      console.log('calculateRoutes 2',apiLoaded,locs)


    const startTag = locs.find(l => isTrue(l.starting_point))
    const endTag = locs.find(l => isTrue(l.ending_point))
    const startPt = startTag ?? home
    const endPt = endTag ?? home
    const mids = locs.filter(l => l !== startTag && l !== endTag)
    const ordered = tspSolver(mids, startPt) || mids

    const rawPts = [
      { lng: +startPt.lng, lat: +startPt.lat },
      ...ordered.map(l => ({ lng: +l.lng, lat: +l.lat })),
      { lng: +endPt.lng, lat: +endPt.lat }
    ]

    const pts = rawPts
      .filter(p => isFiniteNumber(p.lat) && isFiniteNumber(p.lng))
      .filter(p => !(p.lat === 0 && p.lng === 0))

    if (pts.length < 2) throw new Error('Not enough valid coordinates')

   let line

    if (pts.length <= 25) {
      const route = await mapboxDirections(pts)
      line = route.geometry
    } else {
      /*  NEW: use the fixed chunker  */
      const chunks   = chunkArray(pts, 25)
      const fullLine = { type: 'LineString', coordinates: [] }

      for (let i = 0; i < chunks.length; i++) {
        try {
          const partial = await mapboxDirections(chunks[i])
          fullLine.coordinates.push(...partial.geometry.coordinates)
        } catch (e) {
          console.warn(`❌  Chunk #${i + 1} failed (size ${chunks[i].length}).`, e.message)
        }
      }

      if (!fullLine.coordinates.length)
        throw new Error('All route chunks failed')
      line = fullLine
    }

    const list = [
      ...(startPt?.index ? [{ ...startPt, type: 'STARTING_POINT' }] : []),
      ...ordered.map(l => ({ ...l, type: 'WAYPOINT' })),
      ...(endPt?.index && (!startPt?.index || startPt.index !== endPt.index)
        ? [{ ...endPt, type: 'ENDING_POINT' }]
        : [])
    ]

    setMapOrderData(list)
    setDirections(line)
  } catch (err) {
    console.error('[Mapbox] calculateRoutes:', err.message)
    setMapOrderData([])
    setDirections(null)
  }
}




 

  const handleSalesOrderSelect = async (newValue) => {
    if (newValue) {
      console.log('Selected Sales Order:', newValue)
      setSelectedSalesOrder(newValue)
      // Extract installation addresses and fetch geocoded locations
      const geocodedLocations = await fetchInstallationLocations(
        newValue.appointments,
      )

      if (geocodedLocations.length > 0) {
        setLocations(geocodedLocations)
        calculateRoute(geocodedLocations)
      } else {
        console.error('No valid locations for this sales order.')
        setLocations([])
        setDirections(null)
      }
    } else {
      setLocations([])
      setDirections(null)
      setSelectedSalesOrder(null)
    }
  }

  const fetchInstallationLocations = async (appointments) => {
    const locations = []

    for (const appointment of appointments) {
      try {
        const address = `${appointment.address}, ${appointment.city}, ${appointment.state}, ${appointment.zipcode}`

        let latLong = null

        if (appointment.lat && appointment.lng) {
          console.log(
            'getLatandLongFromAddress existing',
            appointment.lat,
            appointment.lng,
          )

          locations.push({
            lat: Number(appointment.lat),
            lng: Number(appointment.lng),
            name: appointment.name,
          })
        } else {
          latLong = await getLatandLongFromAddress(address)
          console.log('getLatandLongFromAddress', latLong)
        }
        if (latLong) {
          locations.push({
            lat: latLong ? latLong.Latitude : appointment.lat,
            lng: latLong ? latLong.Longitude : appointment.lng,
            name: appointment.name,
          })
        }
      } catch (error) {
        console.error('Error geocoding address:', error)
      }
    }

    return locations
  }

  const handleAssignRoute = async () => {
    const user = JSON.parse(window.localStorage.getItem('user'))

    const res = await axios.post(
      `${REST_API_END_POINT}route/assign-ts-job-to-route`,
      {
        selectedRoute,
        selectedSalesOrder,
        selectedDriver,
        selectedTeam,
        isDriver,
        selectTemplate,
        previosSalesOrderId,
        userId: user.user_id,
      },
    )

    if (res.data.status === 1) {
      enqueueSnackbar(
        `Successfully ${
          selectedData.assigned ? 'Re-assigned' : 'Assigned'
        } to Installer`,
        { variant: 'success' },
      )
      //  window.location.reload()
    } else if (res.data.status === 3) {
      enqueueSnackbar(res.data.message, { variant: 'error' })
    } else {
      enqueueSnackbar(
        `Failed to ${selectedData.assigned ? 'Re-assign' : 'Assign'}`,
        { variant: 'error' },
      )
    }
  }

  

  const handleMarkerDragEnd = async (event, index, location) => {
    const newLat = event.latLng.lat()
    const newLng = event.latLng.lng()
    console.log('locationlocationlocation', location)

    // Update the location in the state
    setLocations((prevLocations) => {
      const updatedLocations = [...prevLocations]
      updatedLocations[index] = {
        ...updatedLocations[index],
        lat: Number(newLat),
        lng: Number(newLng),
      }
      // calculateRoute(updatedLocations)
      return updatedLocations
    })

    console.log(
      `Marker ${index} moved to: Latitude: ${newLat}, Longitude: ${newLng}`,
    )

    // Recalculate the route with updated locations
    //update lat long on installation table
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}installation/update-lat-lng`,
        {
          markerId: location.id,
          latitude: Number(newLat), // Ensure latitude is sent as a number
          longitude: Number(newLng), // Ensure longitude is sent as a number
        },
      )

      if (response.data.status === 1) {
        console.log('Marker updated successfully in DB:', response.data)
      } else {
        console.error('Failed to update marker in DB:', response.data)
      }
    } catch (error) {
      console.error('Error updating marker in DB:', error)
    }
  }

  console.log('addedLocations==========', addedLocations)

  return (
    <Grid item xs={12}>
      <Stack direction="column" spacing={2} sx={{ mb: 2 }}>
        <HeaderBreadcrumbs
          sx={{ mt: 2 }}
          heading={`Route Details${
            selectedData?.name ? ` - ${selectedData?.name}` : ''
          }`}
          // action={
          //   <Stack direction="row" spacing={2}>
          //     <Button
          //       sx={{ mt: 2 }}
          //       variant="outlined"
          //       startIcon={
          //         <Stack>
          //           <KeyboardBackspaceOutlined />
          //         </Stack>
          //       }
          //       onClick={() =>
          //         navigate(PATH_DASHBOARD.transportation.routes, {
          //           state: { ts: true },
          //         })
          //       }
          //     >
          //       Back to Routes
          //     </Button>
          //   </Stack>
          // }
        />
      </Stack>

      <Card sx={{ mb: 2 }} variant='outlined'>
        {!details ? (
          <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ 
                    p: 1, 
                    borderRadius: '50%', 
                    bgcolor: 'primary.main', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)'
                  }}>
                    <WorkOutline sx={{ fontSize: 20 }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Job Name
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 600, color: 'text.primary' }}>
                      {details?.name || 'N/A'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ 
                    p: 1, 
                    borderRadius: '50%', 
                    bgcolor: 'success.main', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)'
                  }}>
                    <PersonOutline sx={{ fontSize: 20 }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Client
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 600, color: 'text.primary' }}>
                      {details?.customer_name || 'N/A'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ 
                    p: 1, 
                    borderRadius: '50%', 
                    bgcolor: 'warning.main', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 8px rgba(237, 108, 2, 0.3)'
                  }}>
                    <Business sx={{ fontSize: 20 }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Project
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 600, color: 'text.primary' }}>
                      {details?.community_name || 'N/A'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ 
                    p: 1, 
                    borderRadius: '50%', 
                    bgcolor: '#2ca01c', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 8px rgba(76, 175, 80, 0.3)'
                  }}>
                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover" }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      QB#
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 600, color: 'text.primary' }}>
                      {details?.doc_number || 'N/A'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </Card>

      {isLoading ? (
        <CircularProgress color="inherit" size={20} />
      ) : (
        <>
          {/* <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 3, sm: 2 }}
            sx={{ mb: 2 }}
          >
            <Autocomplete
              sx={{ width: '50%' }}
              multiple
              id="combo-box-demo"
              // options={allProducts || []}
              options={allProducts?.filter(
                (product) =>
                  !selectedProducts?.some(
                    (selectedProduct) => selectedProduct?.id == product?.id,
                  ),
              )}
              value={selectedProducts}
              onChange={(event, newValue) => {
                setSelectedProducts(newValue)
                const selectedProductIds = newValue?.map(
                  (product) => product.id,
                )
                const newLocations = addedLocations?.filter((item) =>
                  selectedProductIds?.includes(item.productId),
                )
                setAddedLocations(newLocations)
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select product" />
              )}
              getOptionLabel={(option) => (option.name ? option.name : '')}
            />
          </Stack> */}
          {selectedProducts?.length > 0 ? (
            <Scrollbar>
              <TableContainer sx={{ minWidth: 500 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sl No.</TableCell>
                      <TableCell>Product Name</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedProducts?.map((data, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>#{index + 1}</TableCell>
                          {/* <TableCell>{data.name}</TableCell> */}
                          <TableCell>
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                            >
                              <div
                                style={{
                                  width: '18px',
                                  height: '18px',
                                  borderRadius: '50%',
                                  backgroundColor: data.color || 'black',
                                }}
                              ></div>
                              <span>{data.name}</span>
                            </Stack>
                          </TableCell>
                          <TableCell>
                         
                            <TextField
                              label="Quantity"
                              type="number"
                              disabled
                              value={data.qty || 0}
                              onChange={(event) => {
                                const qty = Number(event.target.value)
                             
                                handleProductQuantityChange(data, qty, index)
                              }}
                              onWheel={(e) => e.target.blur()}
                              onKeyDown={(event) => {
                                                if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                  const newValue = event.target.value || 0;
                                                  if (newValue < 1 && event.key === 'ArrowDown') {
                                                    event.preventDefault(); 
                                                  }
                                                }
                                              }}
                            />
                          </TableCell>

                           <TableCell>
                             <Tooltip title="Change Color">
                                 <IconButton onClick={() => handleChangeProductColor(data.id)}>
                                 <Refresh />
                               </IconButton>
                              </Tooltip>
                          </TableCell>

                          {/* <TableCell>
                            <IconButton
                              onClick={() => {
                                const newSelectedProducts =
                                  selectedProducts?.filter(
                                    (item, idx) => idx !== index,
                                  )
                                setSelectedProducts(newSelectedProducts)
                                const newLocations = addedLocations?.filter(
                                  (item, idx) => item.productId !== data.id,
                                )
                                setAddedLocations(newLocations)
                              }}
                            >
                              <Delete />
                            </IconButton>
                          </TableCell> */}
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          ) : (
            ''
          )}

         

          {apiLoaded && home && locations && (
            <MapBoxComponent
              markers={addedLocations?.map((location) => ({
                latitude: location.lat,
                longitude: location.lng,
                address: `${location.index}. ${location?.wholeAddress || ''}`,
                raw: location,
                index:location.index,
                color:location.color,
                starting_point:location?.starting_point,
                ending_point:location?.ending_point,
               
              }))}
                // onMarkerHover={handleMarkerHover}  
                 onMarkerClick={handleMarkerClick}  
                // onMarkerLeave={handleMarkerLeave}  
                 home={home}  
                 directions={directions}
                 onMarkerDragEnd={(e, index, marker) => handleMarkerDrag(e, index, marker)}
                onSetPoint={handleSetAsPoint}
                  hasRouteMovingPermission={hasRouteMovingPermission}
                   details={details}
                   sliderSettings={sliderSettings}
            />

          )}


          {/* <Popover
            open={Boolean(selectedLocation) }
            anchorReference="anchorPosition"
          anchorPosition={
        mousePosition
      ? { top: mousePosition.y, left: mousePosition.x }
      : { top: 0, left: 0 } 
  }
            
             onClose={() => {
    clearTimeout(hoverTimeout.current);
    setSelectedLocation(null);
    setMousePosition(null);
  }}
            sx={{ pointerEvents: 'none' }} 
             PaperProps={{
    sx: {
      pointerEvents: 'auto', 
   
    },
  }}
          >
          <Box
         onMouseLeave={() => {
      hoverTimeout.current = setTimeout(() => {
        setSelectedLocation(null);
        setMousePosition(null);
      }, 150);
    }}
     >
            {selectedLocation && (
                <Box sx={{ width: 250, p: 2, position: 'relative' }}

    >
     
    <IconButton
  onClick={(e) => {
    e.stopPropagation(); 
    clearTimeout(hoverTimeout.current);
    setSelectedLocation(null);
    setMousePosition(null);
  }}
  sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}
  size="small"
>
  <Close fontSize="small" />
</IconButton>
               
                <Slider {...sliderSettings}>
                  {selectedLocation?.attachments?.map((attachment, index) => (
                    <Box
                      key={index}
                      component="img"
                      src={attachment?.name}
                      alt="Design"
                      sx={{ width: '100%', height: 120, objectFit: 'cover' }}
                    />
                  ))}
                </Slider>

                
                <Typography variant="h6">
                  {selectedLocation?.productName || ''}
                </Typography>
                <Typography variant="body2">
                  📍 {selectedLocation?.wholeAddress || 'Location'}
                </Typography>
                <Typography variant="body2">
                  📦{' '}
                  {selectedLocation?.quantity
                    ? `Quantity: ${selectedLocation?.quantity}`
                    : ''}
                </Typography>

                {!selectedLocation?.service_image &&
                  selectedLocation?.attachments?.[currentImageIndex] && (
                    <>
                      <Typography variant="body2">
                        ✅ Approved By:{' '}
                        {selectedLocation?.attachments?.[currentImageIndex]
                          ?.approved_by_name || 'Admin'}
                      </Typography>
                      <Typography variant="body2">
                        📅 Approved On:{' '}
                        {selectedLocation?.attachments?.[currentImageIndex]
                          ?.timestamp
                          ? moment
                              .unix(
                                selectedLocation.attachments[currentImageIndex]
                                  .timestamp,
                              )
                              .format('MM-DD-YYYY')
                          : 'N/A'}
                      </Typography>
                    </>
                  )}
              </Box>
              
            )}

        <Box sx={{ maxWidth: 200 }}>
      <Typography sx={{ mb: 1, fontWeight: 600,ml:2 }}>
        Choose an option:
      </Typography>

      <Button
        variant="outlined"
        size="small"
        fullWidth
        onClick={() => handleSetAsPoint('start', markerPopup.location)}
        sx={{ mb: 0.5 ,ml:2}}
      >
        Set as Start
      </Button>

      <Button
        variant="outlined"
        size="small"
        fullWidth
        onClick={() => handleSetAsPoint('end', markerPopup.location)}
        sx={{ mb: 0.5 ,ml:2}}
      >
        Set as End
      </Button>

      <Button
        variant="outlined"
        size="small"
        fullWidth
        onClick={() => handleSetAsPoint('both', markerPopup.location)}
        sx={{ mb: 0.5 ,ml:2}}
      >
        Set as Both
      </Button>

      <Button
        variant="outlined"
        size="small"
        fullWidth
        color="secondary"
        onClick={() => handleSetAsPoint('remove', markerPopup.location)}
         sx={{ mb: 0.5 ,ml:2}}
      >
        Remove Start/End
      </Button>
        </Box>

        </Box>
          </Popover> */}
          
         
          {addedLocations && addedLocations?.length > 0 ? (
            <Stack flexDirection={'row'} justifyContent={'space-between'}>
              <Box sx={{ mt: 2 }}>
                <>
                  <Typography variant="h6">Added Locations</Typography>
                  {mapOrderData?.map((location, index) => {
                    // console.log('locationlocationindex', location)
                    return(
                    <Box key={index} sx={{ mt: 1 }}>
                      <Typography variant="body2">
                        {location.index}. {location.wholeAddress} (
                        {Number(location?.lat).toFixed(6)}, {Number(location?.lng).toFixed(6)}) -{' '}
                        <span style={{ color: 'yellow' }}>{`${
                          location?.productName
                        } ${
                          location?.location_id
                            ? `(${location.location_id})`
                            : ''
                        }`} </span>
                        {' '}

  {location?.starting_point && location?.ending_point ? (
    <span style={{ color: 'green' }}>
      (starting <span style={{ color: 'red' }}>and ending point</span>)
    </span>
  ) : location.starting_point ? (
    <span style={{ color: 'green' }}>(starting point)</span>
  ) : location.ending_point ? (
    <span style={{ color: 'red' }}>(ending point)</span>
  ) : null}
                      </Typography>
                    </Box>
                  )})}
                </>
              </Box>
              <Box
                sx={{ mt: 2, gap: 2, display: 'flex', flexDirection: 'row' }}
              >
                <LoadingButton
                  variant="contained"
                  sx={{ mt: 2, alignSelf: 'flex-start' }}
                  disabled={
                   (( selectedProducts?.length > 0 &&
                    addedLocations?.length ==
                      selectedProducts?.reduce(
                        (sum, item) => sum + Number(item?.qty),
                        0,
                      )
                      ? false
                      : true) || isSaving)
                  }
                  loading={isSaving}
                  onClick={handleSaveLocations}
                >
                  {addedLocations?.length ==
                  selectedProducts?.reduce(
                    (sum, item) => sum + Number(item?.qty),
                    0,
                  )
                    ? 'Save Locations'
                    : 'Loading Locations'}
                </LoadingButton>
                <Button
                  variant="outlined"
                  sx={{
                    mt: 2,
                    alignSelf: 'flex-start', // Align this button to the right
                  }}
                  disabled={addedLocations?.length > 0 ? false : true}
                  onClick={() => {
                    // Conditional check if needed for the route calculation
                    // if(addedLocations.length > 23) {
                    calculateRoutes(addedLocations)
                    // } else {
                    //   calculateRoute(addedLocations);
                    // }
                  }}
                >
                  Generate Route
                </Button>
              </Box>
            </Stack>
          ) : (
            ''
          )}
          <ConfirmationPopup
            open={deleteLocationIndex ? true : false}
            handleClick={handleMarkerDelete}
            message={'You want to delete this location?'}
            handleClose={() => setDeleteLocationIndex(null)}
          />
        </>
      )}
    </Grid>
  )
}

const RouteMap = ({route_id, details}) => {
  console.log('RouteMap details', details)
  const routeId = route_id // map service routeId
  const selectedData = details?.routeData // selected route row data
  const isFromPs= false
  const [mapLoaded, setMapLoaded] = useState(false)
  const [tspSolution, setTspSolution] = useState([])
  const [apiLoaded, setApiLoaded] = useState(false)
  const [loading, setLoading] = useState(true)
  const [selectedSalesOrder, setSelectedSalesOrder] = useState(null)
  const [selectedRoute, setSelectedRoute] = useState(routeId)
  const [routeData, setRouteData] = useState([])
  const [driverData, setDriverData] = useState([])
  const [locations, setLocations] = useState([])
  const [directions, setDirections] = useState([])
  const [allDirections, setAllDirections] = useState([]) // Array to store multiple directions
  const [center, setCenter] = useState()
  // const [home, setHome] = useState()
    // const [home, setHome] = useState({lat: 32.8796404 , lng: -111.7589043}) // Default home location
    const [home, setHome] = useState(null)
  const { google } = window
  const [currentLocation, setCurrentLocation] = useState(null)
  const userData = JSON.parse(localStorage.getItem('user'))
  const { enqueueSnackbar } = useSnackbar()
  const [totalDistance, setTotalDistance] = useState(0)
  const [nearestDistance, setNearestDistance] = useState(0)
  const [fetchingData, setFetchingData] = useState(false)
  const [filteredLocations, setFilteredLocations] = useState([])
  const [value, setValue] = useState('1')
  const [viewRoute, setViewRoute] = useState(false)

  useEffect(() => {
    setSelectedRoute(routeId)
  }, [routeId])

  const getRouteData = () => {}

 const getLatandLongFromAddress = async (address) => {
  try {
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${MAPBOX_ACCESS_TOKEN}`
    )
    const data = await response.json()

    if (data.features && data.features.length > 0) {
      const [lng, lat] = data.features[0].geometry.coordinates
      return {
        Latitude: Number(lat),
        Longitude: Number(lng),
      }
    } else {
      console.error('Mapbox: No results found for address:', address)
      return null
    }
  } catch (error) {
    throw new Error('Mapbox geocoding failed. ' + error.message)
  }
}
  const fetchAllDrivers = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}driver/get-all-verified-active-drivers`,
      )
      if (response.data.status === 1) {
        setDriverData(response.data.drivers)
        console.log('Fetch drivers - ', response.data)
      } else {
        setDriverData([])
      }
    } catch (error) {
      console.log('Error fetching drivers : ', error)
    }
  }

  useEffect(() => {
    fetchAllDrivers()
  }, [home])

  const handleDragEnd = (result) => {
    if (!result.destination) {
      return // Dragged outside of droppable area
    }

    const startIndex = result.source.index
    const endIndex = result.destination.index

    // Update the order of locations in the state
    const newLocations = Array.from(locations)
    const [removed] = newLocations.splice(startIndex, 1)
    newLocations.splice(endIndex, 0, removed)

    setLocations(newLocations)

    // Recalculate directions based on the new order of locations
    // recalculateDirections(newLocations);
  }

  // const fetchDetails = async () => {
  //   try {
  //     const res = await axios.post(
  //       `${REST_API_END_POINT}settings/get-companyProfile-details`,
  //     )
  //     if (res.data.status === 1) {
  //       const companyAddressData = res.data.data[0]
  //       const { address, city, state, zipcode,lat,lng ,id} = companyAddressData
  //       const fullAddress = `${address}, ${city}, ${state}, ${zipcode}`

  //       console.log('Company Address----', fullAddress)
  //       if(!lat && !lng){
  //         const latLong = await getLatandLongFromAddress(fullAddress)
  //         const { Latitude, Longitude } = latLong
  //         setCenter({ lat: Number(Latitude), lng: Number(Longitude) })
  //         setHome({ lat: Number(Latitude), lng: Number(Longitude) })
  //         if(Latitude && Longitude){
  //           console.log('productsssssssss 3')
  //           await handleUpdateCompanyAddress({
  //             id: id,
  //             lat:Latitude,
  //             lng:Longitude,
  //           })}

  //       }else{
  //         setCenter({ lat: Number(lat), lng: Number(lng) })
  //         setHome({ lat: Number(lat), lng: Number(lng) })
  //       }
  //       // if ("geolocation" in navigator) {
  //       //   navigator.geolocation.getCurrentPosition(
  //       //     position => {
  //       //       const { latitude, longitude } = position.coords;
  //       //       console.log('Current latitude:',latitude);
  //       //       console.log('Current longitude : ',longitude);
  //       //       setCenter({ lat:latitude, lng:longitude });
  //       //     },
  //       //     error => {
  //       //       console.error("Error getting user's location:", error);
  //       //     }
  //       //   );
  //       // } else {
  //       //   console.error("Geolocation is not supported by this browser.");
  //       // }
  //     }
  //   } catch (error) {
  //     console.log(error, 'errrrrrr')
  //   }
  // }

  // const handleUpdateCompanyAddress = async (data) => {
  //   try {
  //     const response = await axios.post(`${REST_API_END_POINT}settings/update-company-lat-lng`, data);
  //     if (response.data.status === 1) {
  //       // enqueueSnackbar(response.data.message, { variant: "success" });
  //       console.log('handleUpdateCompanyAddress success', response.data.message)
  //     } else {
  //       // enqueueSnackbar(response.data.message, { variant: "error" });
  //       console.log('handleUpdateCompanyAddress failed', response.data.message)
  //     }
  //   } catch (error) {
  //     console.log("Server error:", error);
  //     // enqueueSnackbar("Server error", { variant: "error" });
  //     console.log('handleUpdateCompanyAddress error', response.data.message)
  //   }
  // };

  const fetchDetails = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}route/get-project-address-by-route`, { selectedRoute }
      )
      if (res.data.status === 1) {
        const companyAddressData = res.data.projectAddress[0]
        const { address, city, state, zip, lat, lng, id } =
          companyAddressData
        // const fullAddress = `${address}, ${city}, ${state}, ${zipcode}`
        const cleanAddress = address?.match(/\d{1,5}.*$/)?.[0] || address;
        const fullAddress = `${cleanAddress}, ${city}, ${state}, ${zip}`;
        console.log("🧼 Cleaned Address:", cleanAddress);
        console.log("📦 Full Address Sent to Mapbox:", fullAddress);

        console.log('Company Address----', fullAddress)
        if (!lat || !lng || Number(lat) === 0 || Number(lng) === 0) {
          try {
            const latLong = await getLatandLongFromAddress(fullAddress);
            if (
              latLong &&
              latLong.Latitude > 20 && latLong.Latitude < 50 &&
              latLong.Longitude < -60 && latLong.Longitude > -130
            ) {
              const { Latitude, Longitude } = latLong;
              console.log("latLonglatLong", latLong);
              setCenter({ lat: Latitude, lng: Longitude });
              setHome({ lat: Latitude, lng: Longitude });
              await handleUpdateCompanyAddress({ id: id, lat: Latitude, lng: Longitude });
            } else {
              console.log("⚠️ Invalid lat/lng from Mapbox. Falling back.");
              setCenter({ lat: 32.8796404, lng: -111.7589043 });
              setHome({ lat: 32.8796404, lng: -111.7589043 });
            }
          } catch (mapboxErr) {
            console.error("❌ Mapbox fetch failed. Using fallback.", mapboxErr);
            setCenter({ lat: 32.8796404, lng: -111.7589043 });
            setHome({ lat: 32.8796404, lng: -111.7589043 });
          }
        }
        else {
          console.log("latLonglatLong", lat, lng)
          setCenter({ lat: Number(lat), lng: Number(lng) })
          setHome({ lat: Number(lat), lng: Number(lng) })
        }

      }
    } catch (error) {
      console.log(error, 'errrrrrr')
      setCenter({ lat: 32.8796404, lng: -111.7589043 });
      setHome({ lat: 32.8796404, lng: -111.7589043 });
    }
  }

  const handleUpdateCompanyAddress = async (data) => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}route/update-community-lat-lng`,
        data,
      )
      if (response.data.status === 1) {
        console.log('handleUpdateCompanyAddress success', response.data.message)
      } else {
        console.log('handleUpdateCompanyAddress failed', response.data.message)
      }
    } catch (error) {
      console.log('Server error:', error)
      console.log('handleUpdateCompanyAddress error', response.data.message)
    }
  }

  useEffect(() => {
    if (!home) {
      fetchDetails()
    }
  }, [selectedRoute])

  // useEffect(() => {
  //   fetchDetails()
  // }, [])



  useEffect(() => {
    console.log('locations===========', locations)
    const loadMap = async () => {
      try {
        if (!window.google || !window.google.maps) {
          throw new Error('Google Maps API is not loaded')
        }

        const tspSolution = tspSolver(locations)
        setTspSolution(tspSolution)

        const orderedLocations = tspSolution.map((index) => locations[index])

        const waypoints = [
          { location: home, stopover: true },
          ...orderedLocations.map((location) => ({
            location: { lat: location?.lat, lng: location?.lng },
            stopover: true,
          })),
          { location: home, stopover: true },
        ]

        const origin = waypoints[0]?.location
        const destination = waypoints[waypoints.length - 1]?.location

        const directionsService = new window.google.maps.DirectionsService()

        directionsService.route(
          {
            origin,
            destination,
            waypoints: waypoints.slice(1, waypoints.length - 1),
            travelMode: 'DRIVING',
          },
          (result, status) => {
            if (status === 'OK') {
              setAllDirections((prev) => [...prev, { result, type: 'forward' }])

              // Calculate total distance
              let distance = 0
              result.routes[0].legs.forEach((leg) => {
                distance += leg.distance.value // Distance in meters
              })
              setTotalDistance((distance / 1000).toFixed(2)) // Convert to km and fix to 2 decimal points
            } else {
              console.error(`Forward route request failed: ${status}`)
            }
          },
        )
      } catch (error) {
        console.error('Error loading routes:', error)
      }
    }

    if (mapLoaded && apiLoaded) {
      loadMap()
    }
  }, [mapLoaded, apiLoaded, locations])

  const calculateNearestInstallation = () => {
    if (!home || locations.length === 0) return

    let minDistance = Infinity
    locations.forEach((location) => {
      const distance = calculateDistance(home, location)
      if (distance < minDistance) {
        minDistance = distance
      }
    })

    setNearestDistance(minDistance.toFixed(2)) // Fix to 2 decimal points
  }

  const filterLatestMarkers = (locations) => {
    const uniqueLocations = new Map()

    locations.forEach((location, index) => {
      const key = `${location.lat},${location.lng}`
      uniqueLocations.set(key, { ...location, index: index + 1 }) // Overwrite to keep the latest marker
    })

    return Array.from(uniqueLocations.values())
  }

  useEffect(() => {
    if (home && locations.length > 0) {
      calculateNearestInstallation()
    }
    if (locations) {
      const uniqueMarkers = filterLatestMarkers(locations)
      setFilteredLocations(uniqueMarkers)
    }
  }, [home, locations])

  const fetchInstallationByRoute = async (appointments) => {
    try {
      if (appointments) {
        const installations = appointments
        const installationData = []
        const seenInstallations = new Set()

        for (const data of installations) {
          if (!seenInstallations.has(data.id)) {
            seenInstallations.add(data.id)
            const latLong = await getLatandLongFromAddress(
              data?.installationAddress,
            )
            // installationData.push({ ...data, lat: latLong?.Latitude, lng: latLong?.Longitude });
            installationData.push({ ...data })
          }
        }
        console.log('Unique installationData:', installationData)
        return installationData
      } else {
        console.log(`No installations found`)
        return []
      }
    } catch (error) {
      console.log('Error fetching installations', error)
      return []
    }
  }

  useEffect(async () => {
    if (selectedSalesOrder) {
      const directionsPromises = [selectedSalesOrder]?.map(
        async (route, index) => {
          const installations = await fetchInstallationByRoute(
            route.appointments,
          )
          if (installations.length >= 1) {
            setLocations(installations)
            const waypoints = [
              { location: home, stopover: true }, // Add home as the first location
              ...installations.map((location) => ({
                location: { lat: location.lat, lng: location.lng },
                stopover: true,
              })),
              { location: home, stopover: true }, // Add home as the last location
            ]
            const origin = waypoints[0]?.location
            const destination = waypoints[waypoints.length - 1]?.location

            const directionsService = new window.google.maps.DirectionsService()
            return new Promise((resolve, reject) => {
              directionsService.route(
                {
                  origin,
                  destination,
                  waypoints: waypoints.slice(1, waypoints.length - 1),
                  travelMode: 'DRIVING',
                },
                (result, status) => {
                  if (status === 'OK') {
                    resolve({ result, index })
                  } else {
                    reject(
                      `Directions request failed for route ${
                        index + 1
                      }: ${status}`,
                    )
                  }
                },
              )
            })
          }
        },
      )

      const directionsResults = await Promise.all(directionsPromises)
      setAllDirections(directionsResults.filter((d) => d !== undefined))
    }
  }, [selectedSalesOrder])

  const containerStyle = {
    // display: 'flex',
    // flexDirection: 'row',
    // justifyContent: 'space-between',
    // alignItems: 'center',
    marginBottom: 10,
    position: 'absolute',
    right: '10px',
    width: '260px',
  }
  const subcontainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: -35,
  }
  let i = 0

  return (
    <Stack spacing={3}>
      <Box
        sx={{
          p: 2,
          mt: 2,
          height: 'fit-content',
          width: '100%',
          borderRadius: 1,
          // bgcolor: 'grey.50012'
        }}
      >
        <MapComponent2
          driverDataaa={driverData}
          home={home}
          details={details}
          selectedSalesOrder={selectedSalesOrder}
          setSelectedSalesOrder={setSelectedSalesOrder}
          selectedRoute={selectedRoute}
          setSelectedRoute={setSelectedRoute}
          locations={locations}
          setLocations={setLocations}
          directions={directions}
          setDirections={setDirections}
          getLatandLongFromAddress={getLatandLongFromAddress}
          selectedData={selectedData}
          isFromPs={isFromPs}
          sales_order_id={details?.id}
        />
      </Box>
    </Stack>
  )
}

export default RouteMap
